<template>
	<div>
		<action-bar></action-bar>
		<div class="column-box" :style="{'margin-bottom': offset+'px'}">
			<column v-for="index in dashboards.columnIndexes" :key="index" :index="index"></column>
			<column v-if="dashboards.editMode&&dashboards.getItemsInColumn(0)>0" :index="dashboards.columnCount"></column>
		</div>
	</div>
</template>

<script setup lang="ts">
import ActionBar from '@/components/dashboard/ActionBar.vue'
import Column from '@/components/dashboard/DashColumn.vue'
import { useSettingsStore } from '@/stores/Settings'
import globalEvents from '@/utilities/GlobalEvents'
import { useDashboardsStore } from '@/stores/Dashboards'
import { useI18n } from 'vue-i18n'
import { onMounted, ref } from 'vue'
import { DashboardMode } from '@/stores/Dashboards.types'

const ss = useSettingsStore()
const dashboards = useDashboardsStore()
const { t } = useI18n()

const offset = ref(0)

globalEvents.on('Dashboard:Create', () => { // invoked from menu to create a new dashboard
	if (!dashboards.mayEdit) {
		globalEvents.emit('CommonErrorModal', { header: t('layout.createDeniedHeader'), message: t('layout.createDeniedMessage') })
	} else {
		dashboards.create()
	}
})

globalEvents.on('Dashboard:Edit', () => { // invoked from menu to edit current dashboard
	if (!dashboards.mayEdit) {
		globalEvents.emit('CommonErrorModal', { header: t('layout.editDeniedHeader'), message: t('layout.editDeniedMessage') })
	} else if (dashboards.dashboard) {
		dashboards.edit()
	}
})

globalEvents.on('Dashboard:Wallboard', (mode: boolean) => {
	if (mode) {
		// Switch to wallboard rendering
		dashboards.mode = DashboardMode.WALLBOARD
	} else {
		// Switch to normal rendering
		dashboards.mode = DashboardMode.NORMAL
	}
	ss.settings.windowWallboardMode = mode
})

onMounted(() => {
	setTimeout(() => {
		if (document.getElementById('status-panel') != null) {
			offset.value = 17
		}
	}, 500)
})
</script>

<style scoped>
	.column-box {
		display: flex;
		margin-top: 10px;
		margin-left: 5px;
		margin-right: 5px;
		text-align: left;
		overflow:auto;
	}
</style>
